<template>
  <div>
    <el-dialog
      ref="importDataDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="abow_dialog h260_dialog"
      width="720px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogImportForm"
        :model="dialogImportForm"
        :rules="dialogImportFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            批量导入信息
          </h3>
          <div class="modal-row-box">
            <el-row style="margin-top: 10px; margin-bottom: 12px;">
              <el-col :span="24">
                <el-upload
                  ref="activityDispatchUpload"
                  class="upload-file"
                  :action="serverUrl + action"
                  :multiple="false"
                  :data="requestParam"
                  :accept="accept"
                  :headers="headers"
                  :on-remove="handleOnRemove"
                  :on-change="handleOnChange"
                  :on-success="handleOnSuccess"
                  :on-error="handleOnError"
                  :on-exceed="handleOnExceed"
                  :before-upload="handleBeforeUpload"
                  :file-list="fileList"
                  :limit="1"
                  :auto-upload="false"
                >
                  <div style="display: flex;">
                    <el-button
                      slot="trigger"
                      size="mini"
                      type="primary"
                    >
                      选择文件
                    </el-button>
                    <div
                      slot="tip"
                      class="el-upload__tip"
                      style="color: red; margin-left: 30px;"
                    >
                      只能上传EXCEL文件，且文件大小不超过20M.
                    </div>
                  </div>
                </el-upload>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="success"
          icon="el-icon-upload2"
          @click="submitUpload"
        >
          开始导入
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>

    <!-- 错误提示弹窗 -->
    <el-dialog
      :title="'导入错误信息'"
      :visible.sync="dialogErrorMsgVisible"
      width="35%"
      class="message-dialog"
      :before-close="modalErrorMsgClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <div class="message-box">
        <div class="bd">
          <ul>
            <li
              v-for="(data,index) in messageData"
              :key="index"
              class="err-list"
            >
              {{ data }}
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken, getUserInfo } from "@/utils/auth";

export default {
  name: 'ActivityDispatchFileUpload',
  components: {},
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      serverUrl: process.env.VUE_APP_BASE_V2_API,
      action: 'tms-web/userInsurancePolicy/importData',
      accept: '.xlsx',
      loading: null,
      fileList: [],
      requestParam: {},
      headers: {},
      dialogImportForm: {},
      dialogImportFormRules: {},
      dialogErrorMsgVisible: false,
      messageData: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        if (_this.loading !== null) {
          _this.loading.close()
        }

        let user = JSON.parse(getUserInfo());
        _this.headers["X-Token"] = getToken();
        _this.requestParam["token"] = getToken();
        _this.requestParam["operatorId"] = user.id;
        _this.requestParam["operatorName"] = user.name;

        _this.dialogImportForm = {
          versionCode: '',
          newestVersion: 2
        }
        _this.fileList = [];
      }
    }
  },
  methods: {
    // 删除文件
    handleOnRemove () {
      let _this = this;
      _this.fileList = [];
    },
    // 选择文件
    handleOnChange (file, fileList) {
      let _this = this;
      _this.fileList = fileList;
    },
    // 上传成功
    handleOnSuccess (response) {
      let _this = this;
      if (response.code === 100000) {
        console.log('data', response.data)
        if (response.data) {
          if (_this.loading !== null) {
            _this.loading.close();
          }
          // 弹出错误信息提示弹框
          _this.messageData = response.data;
          _this.dialogErrorMsgVisible = !_this.dialogErrorMsgVisible;
          _this.modalClose()
        } else {
          _this.$message({ message: '保单数据导入成功', type: 'success' })
          _this.$emit('reloadData')
          _this.modalClose()
        }
      } else {
        if (_this.loading !== null) {
          _this.loading.close();
        }
        _this.$message.error(response.message)
      }
    },
    // 上次失败
    handleOnError () {
      let _this = this;
      if (_this.loading !== null) {
        _this.loading.close();
      }
      _this.$message.error('保单数据导入失败')
    },
    // 上传之前处理
    handleBeforeUpload (file) {
      let _this = this;
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (_this.accept.indexOf(extension) < 0) {
        _this.$message.error('文件格式错误')
        return false
      } else {
        return true
      }
    },
    handleOnExceed () {
      this.$message.error('只可上传1个文件')
    },
    submitUpload () {
      let _this = this;
      _this.$refs.dialogImportForm.validate(valid => {
        if (valid) {
          if (_this.fileList.length === 0) {
            _this.$message.error('请选择要导入的数据文件');
            return;
          }

          _this.$confirm('确认导入保单数据？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            _this.$refs.activityDispatchUpload.submit();
            _this.loading = _this.$loading({
              lock: true,
              text: '数据上传处理中,请稍后...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
          }).catch(() => { })
        }
      })
    },
    modalClose () {
      let _this = this;
      // 直接修改父组件的属性
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogImportForm.clearValidate()
    },
    modalErrorMsgClose () {
      let _this = this;
      _this.dialogErrorMsgVisible = !_this.dialogErrorMsgVisible;
    }
  }
}
</script>
<style lang="scss" scoped>
.bd ul {
  padding: 5px 20px 0;
  margin: 0;
  margin-bottom: 10px;
}
.err-list {
  padding: 0;
  margin: 0;
  list-style: none;
  line-height: 24px;
}
</style>